import { posthog } from "posthog-js";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { environment } from "../../environments";

// This is configured in posthog
//
// You can manually toggle using toolbar
// or
// ```
// window.__ph.featureFlags.overrideFeatureFlags({
//     flags: {
//         'feature-name': true,
//         'variant-feature': 'value_a',
//     }
// })
// ```

export const SITE_COMBO_V2_ENABLED = "site-combo-v2-enabled";
export const SITE_COMBO_V2_FLAG_VALUE = "enabled";

const cache = new Map<string, Observable<boolean | string>>();

function getFeatureFlag$(featureName: string): Observable<boolean | string> {
  const cachedValue = cache.get(featureName);
  if (cachedValue) {
    return cachedValue;
  }

  const f = environment.FEATURES_STATE;
  if (typeof f === "boolean") {
    const r = of(f).pipe(shareReplay(1));
    cache.set(featureName, r);
    return r;
  }

  const subject = new BehaviorSubject<boolean | string>(false);

  const checkFeature = () => {
    const v = posthog.getFeatureFlag(featureName);
    subject.next(v || false);
  };
  posthog.onFeatureFlags(() => {
    checkFeature();
  });

  const r = subject.pipe(shareReplay(1));
  cache.set(featureName, r);
  return r;
}

export function IsFeatureEnable(
  featureName: string,
  expectedValue?: string | boolean
): Observable<boolean | string> {
  const flag$ = getFeatureFlag$(featureName);
  if (expectedValue === undefined) {
    return flag$;
  }

  return flag$.pipe(
    map((value) => value === expectedValue || value === true)
  );
}
